import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitojaipurcab() {



    const cardData = {





keyword: "Mumbai to Jaipur Cab",

headingDescription: "Shreesha Tours & Travels offers comfortable and reliable Mumbai to Jaipur Cab Service for family vacations, business trips, corporate travel, sightseeing tours, one-way cab booking, round trips, and long-distance journeys. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options for a safe and convenient travel experience from Mumbai to Jaipur. With experienced drivers, well-maintained vehicles, transparent pricing, doorstep pickup, flexible travel plans, and 24/7 customer support, we ensure a smooth and hassle-free journey. Whether you are visiting Jaipur for tourism, heritage exploration, business requirements, or family travel, Shreesha Tours & Travels provides dependable Mumbai to Jaipur cab booking services with complete comfort and convenience.",

topPlaces: [
  {
    title: "Amber Fort Jaipur",
    description: "Amber Fort is one of Jaipur's most famous historical landmarks, known for grand Rajput architecture, beautiful palaces, courtyards, and stunning views of the surrounding hills."
  },
  {
    title: "Hawa Mahal Jaipur",
    description: "Hawa Mahal, also known as the Palace of Winds, is an iconic Jaipur attraction famous for its unique honeycomb design, royal history, and beautiful pink architecture."
  },
  {
    title: "City Palace Jaipur",
    description: "City Palace is a magnificent royal complex featuring museums, courtyards, gardens, and traditional Rajasthani architecture showcasing Jaipur's royal heritage."
  },
  {
    title: "Jantar Mantar Jaipur",
    description: "Jantar Mantar is a UNESCO World Heritage Site known for its historic astronomical instruments and scientific importance from the royal era."
  },
  {
    title: "Nahargarh Fort Jaipur",
    description: "Nahargarh Fort offers panoramic views of Jaipur city and is famous for its historic architecture, royal stories, and beautiful sunset views."
  },
  {
    title: "Jaigarh Fort Jaipur",
    description: "Jaigarh Fort is a historic hill fort known for massive walls, ancient structures, and the famous Jaivana Cannon. It is a popular destination for history lovers."
  },
  {
    title: "Jal Mahal Jaipur",
    description: "Jal Mahal is a beautiful palace located in the middle of Man Sagar Lake, known for its scenic views, photography spots, and unique architecture."
  },
  {
    title: "Chokhi Dhani Jaipur",
    description: "Chokhi Dhani offers an authentic Rajasthani cultural experience with traditional food, folk performances, village activities, and local entertainment."
  },
  {
    title: "Pushkar",
    description: "Pushkar is a famous pilgrimage town near Jaipur known for Brahma Temple, Pushkar Lake, colorful markets, and cultural attractions."
  },
  {
    title: "Ajmer Dargah",
    description: "Ajmer is a popular spiritual destination near Jaipur, famous for Ajmer Sharif Dargah and its rich cultural and religious significance."
  }
],


"services": [
  {
    "name": "Mumbai to Jaipur Cab",
    "description": "Book Mumbai to Jaipur Cab for safe, comfortable, and reliable long-distance travel with professional chauffeurs and well-maintained AC vehicles. Enjoy a smooth interstate journey from Mumbai to Jaipur with Sedan, Ertiga, Innova, Innova Crysta, SUV, and luxury cab options suitable for family trips, business travel, and tourist journeys."
  },
  {
    "name": "Mumbai to Jaipur Taxi",
    "description": "Choose Mumbai to Jaipur Taxi for convenient and affordable transportation with experienced drivers and comfortable vehicles. Get doorstep pickup, clean AC cars, transparent pricing, and reliable taxi service for personal, corporate, and holiday travel needs."
  },
  {
    "name": "Mumbai to Jaipur Cab Service",
    "description": "Book Mumbai to Jaipur Cab Service for dependable interstate travel with trained chauffeurs and premium vehicles. Our cab services provide comfortable solutions for family vacations, corporate journeys, airport transfers, and Rajasthan tour travel requirements."
  },
  {
    "name": "Mumbai to Jaipur Taxi Service",
    "description": "Hire Mumbai to Jaipur Taxi Service for smooth highway travel with professional drivers and well-maintained cars. Enjoy flexible booking options, comfortable seating, affordable fares, and reliable taxi facilities for your journey from Mumbai to Jaipur."
  },
  {
    "name": "Mumbai to Jaipur Cab Booking",
    "description": "Complete Mumbai to Jaipur Cab Booking with easy reservations, quick confirmation, and multiple vehicle choices. Select Sedan, SUV, Ertiga, Innova, Innova Crysta, or premium cars according to your travel needs and group size."
  },
  {
    "name": "Mumbai to Jaipur Car Rental",
    "description": "Choose Mumbai to Jaipur Car Rental for chauffeur-driven vehicles designed for comfortable interstate travel. Enjoy spacious cars, professional drivers, flexible schedules, and affordable rental packages for family trips, business travel, and Rajasthan sightseeing tours."
  },
  {
    "name": "Mumbai to Jaipur One Way Cab",
    "description": "Book Mumbai to Jaipur One Way Cab for convenient drop taxi service without return fare charges. Travel comfortably with skilled drivers, clean vehicles, and flexible pickup facilities for a hassle-free one-way journey."
  },
  {
    "name": "Mumbai to Jaipur Round Trip Taxi",
    "description": "Reserve Mumbai to Jaipur Round Trip Taxi for complete return travel with flexible timings and comfortable vehicles. Ideal for Rajasthan vacations, business visits, family tours, and extended stays with reliable chauffeur-driven service."
  },
  {
    "name": "Mumbai to Jaipur Outstation Cab",
    "description": "Choose Mumbai to Jaipur Outstation Cab for safe and reliable long-distance transportation with premium vehicles and experienced chauffeurs. Perfect for interstate travel, tourist trips, corporate journeys, and family vacations."
  },
  {
    "name": "Mumbai Airport to Jaipur Cab",
    "description": "Book Mumbai Airport to Jaipur Cab for smooth airport transfer and direct interstate travel. Enjoy timely pickup, luggage-friendly vehicles, professional chauffeurs, and comfortable transportation from Mumbai Airport to Jaipur."
  },
  {
    "name": "Mumbai to Jaipur Private Taxi",
    "description": "Hire Mumbai to Jaipur Private Taxi for personalized travel with a dedicated vehicle and professional chauffeur. Enjoy privacy, flexible routes, comfortable seating, and a peaceful journey for business or personal transportation."
  },
  {
    "name": "Mumbai to Jaipur Innova Cab",
    "description": "Choose Mumbai to Jaipur Innova Cab for spacious and comfortable travel with premium seating and extra luggage space. Perfect for families and groups planning a relaxing long-distance journey to Jaipur."
  },
  {
    "name": "Mumbai to Jaipur Ertiga Cab",
    "description": "Reserve Mumbai to Jaipur Ertiga Cab for affordable group travel with comfortable interiors and reliable performance. Suitable for families and small groups looking for economical and convenient outstation transportation."
  },
  {
    "name": "Mumbai to Jaipur Luxury Cab",
    "description": "Book Mumbai to Jaipur Luxury Cab for premium travel with stylish vehicles, professional chauffeurs, and enhanced comfort. Ideal for corporate travel, special occasions, business trips, and passengers seeking a premium journey experience."
  },
  {
    "name": "Reliable Mumbai Jaipur Taxi Service",
    "description": "Choose Reliable Mumbai Jaipur Taxi Service for safe, comfortable, and affordable interstate travel. Enjoy premium vehicles, trained chauffeurs, flexible booking options, transparent pricing, and dependable service for family trips, corporate journeys, airport transfers, and Rajasthan tours."
  }
],
"tableData": [
  ["Mumbai to Jaipur Cab", "Mumbai to Jaipur Taxi"],
  ["Mumbai to Jaipur Cab Service", "Mumbai to Jaipur Taxi Service"],
  ["Mumbai to Jaipur Cab Booking", "Mumbai to Jaipur Car Rental"],
  ["Mumbai to Jaipur One Way Cab", "Mumbai to Jaipur Round Trip Taxi"],
  ["Mumbai to Jaipur Outstation Cab", "Mumbai Airport to Jaipur Cab"],
  ["Mumbai to Jaipur Private Taxi", "Mumbai to Jaipur Innova Cab"],
  ["Mumbai to Jaipur Ertiga Cab", "Mumbai to Jaipur Luxury Cab"],
  ["Reliable Mumbai Jaipur Taxi Service", ""]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Jaipur Cab Service",
    WhyChoosedescription: "Shreesha Travels offers comfortable Mumbai to Jaipur cab services for families, tourists, business travellers, and personal journeys. Travel to the Pink City with professional chauffeurs, spacious vehicles, and flexible travel solutions."
  },
  {
    WhyChooseheading: "Comfortable Long-Distance Road Journey",
    WhyChoosedescription: "Enjoy a smooth interstate travel experience from Mumbai to Jaipur with private chauffeur-driven cabs, convenient pickup options, and a comfortable ride throughout the journey."
  },
  {
    WhyChooseheading: "Vehicle Options for Every Travel Requirement",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles based on passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "Perfect for Rajasthan Tours & Family Trips",
    WhyChoosedescription: "Our Mumbai to Jaipur taxis are ideal for Rajasthan sightseeing tours, family vacations, wedding travel, business visits, historical tours, and customized travel plans."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Packages",
    WhyChoosedescription: "Book a one-way cab for direct travel to Jaipur or choose a round-trip package with flexible return dates, waiting options, and customized travel arrangements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Interstate Routes",
    WhyChoosedescription: "Our professional chauffeurs have experience with long highway routes and provide safe driving, timely service, and a comfortable journey from Mumbai to Jaipur."
  },
  {
    WhyChooseheading: "Clean & Comfortable Cars for Long Trips",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and inspected before departure to ensure a safe and enjoyable travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Jaipur Cab with Shreesha Travels",
    WhyChoosedescription: "Get transparent pricing, easy booking support, reliable vehicles, and professional chauffeur services for your Mumbai to Jaipur road journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Jaipur cab for a Rajasthan tour?",
    answer: "Yes, our Mumbai to Jaipur cabs are suitable for Rajasthan sightseeing, family vacations, business trips, and customized travel plans."
  },
  {
    question: "Is Mumbai to Jaipur one-way cab service available?",
    answer: "Yes, one-way taxi booking is available for passengers who need direct transportation from Mumbai to Jaipur."
  },
  {
    question: "Which cars are available for Mumbai to Jaipur travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I book a round-trip taxi from Mumbai to Jaipur?",
    answer: "Yes, round-trip packages are available with flexible return schedules and customized travel options."
  },
  {
    question: "Is Mumbai to Jaipur cab service suitable for families?",
    answer: "Yes, spacious vehicles with experienced drivers provide comfortable travel for families with luggage."
  },
  {
    question: "Can I include sightseeing places during my Jaipur trip?",
    answer: "Yes, customized itineraries can include Jaipur attractions, nearby destinations, and Rajasthan sightseeing locations."
  },
  {
    question: "Do you provide cabs for Jaipur wedding travel?",
    answer: "Yes, our vehicles are available for wedding guests, family transportation, and special event travel requirements."
  },
  {
    question: "How is the Mumbai to Jaipur cab fare calculated?",
    answer: "The fare depends on vehicle type, travel distance, trip duration, route, driver charges, and additional requirements."
  },
  {
    question: "Are overnight Mumbai to Jaipur journeys available?",
    answer: "Yes, overnight travel options are available with experienced drivers for comfortable long-distance journeys."
  },
  {
    question: "How can I book Mumbai to Jaipur Cab with Shreesha Travels?",
    answer: "Share your pickup location, travel date, passenger details, preferred vehicle, and trip requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Arjun Mehta",
    feedback: "The Mumbai to Jaipur journey was excellent. The vehicle was comfortable, the driver was professional, and the complete road trip was handled smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Poonam Sharma",
    feedback: "Our family Rajasthan trip started perfectly with Shreesha Travels. The clean car, safe driving, and helpful service made the long journey enjoyable.",
    rating: 5
  }
];


    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Jaipur Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-jaipur-cab.webp",
  "description":
    "Book Mumbai to Jaipur Cab with Shreesha Tours & Travels for comfortable and reliable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for family trips, business travel, sightseeing tours, one-way, round-trip, and long-distance journeys from Mumbai to Jaipur with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-jaipur-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Mumbai to Jaipur Cab | Outstation Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Jaipur Cab with Shreesha Travels for safe and comfortable outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for one-way, round-trip, family vacations, business travel, and sightseeing tours with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Jaipur Cab, Mumbai to Jaipur Taxi, Mumbai to Jaipur Cab Service, Mumbai to Jaipur Taxi Service, Mumbai to Jaipur Cab Booking, Mumbai to Jaipur Car Rental, Mumbai to Jaipur One Way Cab, Mumbai to Jaipur Round Trip Taxi, Mumbai to Jaipur Outstation Cab, Mumbai to Jaipur Taxi Booking, Jaipur Tour Cab from Mumbai, Mumbai Jaipur Car Hire"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/76.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitojaipurcab;